import React, { useEffect, useState } from 'react';
import { XIcon, BookHeartIcon } from 'lucide-react';
const names = ['María', 'Carolina', 'Valentina', 'Andrea', 'Lucía', 'Gabriela', 'Daniela', 'Sofía', 'Camila', 'Ana', 'Patricia', 'Laura', 'Isabel', 'Rosa', 'Fernanda'];
const cities = ['Bogotá', 'Ciudad de México', 'Lima', 'Buenos Aires', 'Santiago', 'Medellín', 'Quito', 'Guadalajara', 'Montevideo', 'San José', 'Caracas', 'Panamá', 'Asunción', 'La Paz', 'Santo Domingo'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    if (isDismissed) return;
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay of 8 seconds
    const initialTimer = setTimeout(() => {
      showPopup();
      // Then cycle every 8 seconds (4s visible + 4s hidden)
      const interval = setInterval(showPopup, 8000);
      return () => clearInterval(interval);
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  if (isDismissed) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-222">
      <div className="bg-white rounded-xl shadow-lg border p-4 max-w-xs flex items-start gap-3 relative" style={{
      borderColor: 'var(--color-border)'
    }} data-id="element-223">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar" data-id="element-224">
          <XIcon className="w-4 h-4" data-id="element-225" />
        </button>

        <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
        backgroundColor: '#FDF2EC'
      }} data-id="element-226">
          <BookHeartIcon className="w-5 h-5" style={{
          color: 'var(--color-soft-peach)'
        }} data-id="element-227" />
        </div>

        <div className="pr-4" data-id="element-228">
          <p className="text-sm font-bold leading-tight" style={{
          color: 'var(--color-deep-blue)'
        }} data-id="element-229">
            {currentName} de {currentCity}
          </p>
          <p className="text-xs mt-1" style={{
          color: 'var(--color-body)'
        }} data-id="element-230">
            acaba de adquirir este libro
          </p>
          <p className="text-[10px] mt-1.5 font-medium opacity-70" style={{
          color: 'var(--color-soft-blue)'
        }} data-id="element-231">
            Hace unos minutos
          </p>
        </div>
      </div>
    </div>;
}